<template>
  <div class="dashboard">
    <HeaderBar />
    <div class="main-content">
      <div class="left-panel">
        <SummaryCards />
        <div class="circle-charts">
          <MetricsChart />
        </div>
        <div class="circle-charts">
          <DeviceMetricsChart />
        </div>
        <div class="ranking-charts">
          <PieChart
            :name="'report-unqualified'"
            :title="'报告质控不良事件占比'"
            :data="reportUnqualifiedData"
          />
          <PieChart
            :name="'image-unqualified'"
            :title="'影像质控不良事件占比'"
            :data="imageUnqualifiedData"
          />
          <!-- <DoctorRanking />
          <TechnicianRanking /> -->
        </div>
      </div>
      <div class="center-panel">
        <MapOverview />
        <div class="total-num-box">
          <TotalNum :data="totalNumData" />
        </div>
      </div>
      <div class="right-panel">
        <div class="right-panel-top">
          <CenterRankingBar />
        </div>
        <div class="right-panel-charts">
          <MonthlyReportBar />
          <MonthlyUnqualifiedLine />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import HeaderBar from "@/components/HeaderBar.vue";
import SummaryCards from "@/components/SummaryCards.vue";
import MetricsChart from "@/components/MetricsChart.vue";
import DeviceMetricsChart from "@/components/DeviceMetricsChart.vue";
import PieChart from "@/components/PieChart.vue";
import TotalNum from "@/components/TotalNum.vue";
// import ScanTypeChart from "@/components/ScanTypeChart.vue";
// import CheckTypeChart from "@/components/CheckTypeChart.vue";
import DoctorRanking from "@/components/DoctorRanking.vue";
import TechnicianRanking from "@/components/TechnicianRanking.vue";
import MapOverview from "@/components/MapOverview.vue";
import CenterRankingBar from "@/components/CenterRankingBar.vue";
import MonthlyReportBar from "@/components/MonthlyReportBar.vue";
import MonthlyUnqualifiedLine from "@/components/MonthlyUnqualifiedLine.vue";
</script>

<script>
import { ref } from "vue";
export default {
  name: "DashboardView",
};
const reportUnqualifiedData = ref([
  {
    name: "主要病变定位错误或定性错误",
    value: 134,
  },
  {
    name: "病变描述部分审核不认真，存在错别字；有计量单位错误",
    value: 20,
  },
  {
    name: "诊断结论不全面，主次不得当，结论不适当",
    value: 100,
  },
  {
    name: "不能明确诊断时仅描述，没有给出必要的处理建议和意见",
    value: 70,
  },
  {
    name: "不关注危急值，没有及时报告",
    value: 10,
  },
]);
const imageUnqualifiedData = ref([
  {
    name: "摄影和检查部位准确（申请单要求），影像图像显示解剖图像位置标准",
    value: 44,
  },
  {
    name: "检查技术适用恰当，影像具有良好的对比度、清晰度、层次分明",
    value: 10,
  },
  {
    name: "无体外伪影（体外、呼吸运动设备原因）",
    value: 10,
  },
  {
    name: "检查序列、图像齐全，显示方式正确",
    value: 10,
  },
  {
    name: "检查技术不当或操作过失造成不能用于诊断者",
    value: 1,
  },
]);
const totalNumData = ref([
  {
    name: "历史质控报告数量",
    value: 13423,
  },
  {
    name: "历史质控不良事件数量",
    value: 134,
  },
  {
    name: "历史报告合格率",
    value: "98.5%",
  },
  {
    name: "报告互认机构数量",
    value: 35,
  },
]);
</script>

<style scoped lang="less">
@import "@/assets/css/global.less";
.dashboard {
  width: 100vw;
  height: 100vh;
  background: #101c36;
  display: flex;
  flex-direction: column;
}
.main-content {
  flex: 1;
  display: flex;
  flex-direction: row;
  padding: 16px;
  box-sizing: border-box;
}
.left-panel {
  width: 500px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  overflow: hidden;
}
.circle-charts {
  display: flex;
}
.ranking-charts {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  > div {
    flex: 1;
  }
}
.center-panel {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  .total-num-box {
    position: absolute;
    bottom: 50px;
    left: 0;
    width: 100%;
    height: 100px;
    z-index: 9;
  }
}
.right-panel {
  width: 500px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  .right-panel-charts {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 16px;
    > div {
      flex: 1;
    }
  }
}
</style>
